// extracted by mini-css-extract-plugin
export default {"title":"styles_title__tMqf4","container":"styles_container__PKlek","links":"styles_links__A-zEh"};